import { Box } from "@mui/material";
import FilterSelect from "../../../../../../../components/FilterSelect";
import { createMapper } from "../../../../../../../utils/utils";
import { VisitNote } from "../../../../patient/patient-list/patient-chart-new/patient-visit-note/encounter/components/ActiveForm";

interface VisitNoteFormsProps {
  onOptionClick: (v: VisitNote) => void;
  selectedForm?: string;
}

const VisitNoteForms = ({
  onOptionClick,
  selectedForm,
}: VisitNoteFormsProps) => {
  return (
    <Box
      sx={{
        width: "220px",
      }}
    >
      <FilterSelect
        disableSortOptions
        clearable={false}
        placeholder="Visit Note Type"
        options={DEFAULT_FORM_LIST.map((it) => ({
          value: it.value,
          label: it.name,
        }))}
        value={selectedForm ?? null}
        onChange={(val) => {
          if (val) {
            onOptionClick(val as VisitNote);
          }
        }}
      />
    </Box>
  );
};

export default VisitNoteForms;

type DefaultForm = {
  name: string;
  value: VisitNote;
};

export const DEFAULT_FORM_LIST: DefaultForm[] = [
  { name: "Simple SOAP Note", value: "SIMPLE_SOAP_NOTE" },
  { name: "Primary Care SOAP Note", value: "PRIMARY_CARE_SOAP_NOTE" },
  { name: "Psychiatric Note", value: "PSYCHIATRIC_NOTE" },
  // { name: "Treatment Plan", value: "TREATMENT_PLAN" },
  // { name: "Pre-Operative Note", value: "PREOPERATIVE_NOTE" },
  {
    name: "Initial Psychiatric Evaluation",
    value: "INITIAL_PSYCHOTHERAPY",
  },
  // { name: "Free SOAP Note", value: "FREE_SOAP_NOTE" },
  // { name: "Psychodynamic Therapy", value: "PSYCHODYNAMIC_THERAPY_NOTE" }, // ECRH-5045: hidden from dropdown; available under Individual psychotherapy note
  { name: "Psychotherapy Note", value: "PSYCHOTHERAPY_NOTE" },
  // { name: "Individual Therapy Note", value: "INDIVIDUAL_THERAPY_NOTE" },
  { name: "Psychoeducation Therapy", value: "PSYCHOEDUCATION_THERAPY" },
  { name: "Collaborative Care Model", value: "COLLABORATIVE_CARE_MODEL" },
  { name: "Psychiatric Progress Exam", value: "PSYCHIATRIC_PROGRESS" },
  { name: "DAP Note", value: "DAP_NOTE" },
  { name: "BIRP Note", value: "BIRP_NOTE" },
  { name: "Progress Note", value: "PROGRESS_NOTE" },
];

export const ENCOUNTER_FORM_MAPPER = createMapper(
  DEFAULT_FORM_LIST?.map((it) => ({ value: it?.value, label: it?.name }))
);
